import React from "react";

const NoPageComp = () =>
{
    
    return <center><h1 className="title">Page Not Found</h1></center>
}
export default NoPageComp;